import { jsx } from "react/jsx-runtime";
import react from "react";
import { cn } from "../../../utils/index.js";
import { Fade } from "../Fade/index.js";
const StaggerFadeContainer = ({ children, className, fadeInClass = 'animate-fade-in-0-100', itemDelayMs = 60, disableAnimation = false })=>{
    const staggerVar = (delayMs)=>({
            '--pcln-stagger-delay': `${delayMs}ms`
        });
    const [ready, setReady] = react.useState(false);
    react.useLayoutEffect(()=>{
        setReady(true);
    }, []);
    const wrapperClass = cn(className);
    if (!/*#__PURE__*/ react.isValidElement(children)) return /*#__PURE__*/ jsx("div", {
        className: wrapperClass,
        children: children
    });
    const container = children;
    if (disableAnimation) return /*#__PURE__*/ jsx("div", {
        className: wrapperClass,
        "data-testid": "qa-fade-stagger-wrapper",
        children: /*#__PURE__*/ react.cloneElement(container, container.props, container.props.children)
    });
    if (!ready) {
        const hiddenItems = react.Children.map(container.props.children, (child, idx)=>{
            if (!/*#__PURE__*/ react.isValidElement(child)) return child;
            return /*#__PURE__*/ jsx(Fade, {
                asChild: true,
                isVisible: false,
                className: "pcln-stagger-delay",
                style: {
                    animation: 'none',
                    ...staggerVar(idx * itemDelayMs),
                    opacity: 0,
                    willChange: 'opacity, transform'
                },
                children: child
            });
        });
        return /*#__PURE__*/ jsx("div", {
            className: wrapperClass,
            "data-testid": "qa-fade-stagger-wrapper",
            children: /*#__PURE__*/ react.cloneElement(container, void 0, hiddenItems)
        });
    }
    const wrappedItems = react.Children.map(container.props.children, (child, idx)=>{
        if (!/*#__PURE__*/ react.isValidElement(child)) return child;
        return /*#__PURE__*/ jsx(Fade, {
            asChild: true,
            isVisible: true,
            fadeInClass: fadeInClass,
            className: "pcln-stagger-delay",
            style: {
                ...staggerVar(idx * itemDelayMs),
                animationFillMode: 'both',
                willChange: 'opacity, transform'
            },
            children: child
        });
    });
    return /*#__PURE__*/ jsx("div", {
        className: wrapperClass,
        "data-testid": "qa-fade-stagger-wrapper",
        children: /*#__PURE__*/ react.cloneElement(container, void 0, wrappedItems)
    });
};
export { StaggerFadeContainer };
